import { z } from 'zod';
import { booleanish, cents, dateKey, optionalCents, optionalText, paginationQuery, requiredText } from './common';
import { PAYMENT_METHOD_TYPES } from '../settings';

export const customerInputSchema = z.object({
  name: requiredText(120, 'Informe o nome do cliente'),
  phone: optionalText(30),
  email: z
    .string()
    .trim()
    .toLowerCase()
    .email('E-mail inválido')
    .max(254)
    .nullish()
    .or(z.literal('').transform(() => null)),
  document: optionalText(20),
  birthDate: dateKey.nullish(),
  notes: optionalText(2000),
  zipCode: optionalText(9),
  street: optionalText(120),
  number: optionalText(20),
  complement: optionalText(60),
  district: optionalText(80),
  city: optionalText(80),
  state: optionalText(2),
  tags: z.array(z.string().trim().max(30)).max(20).default([]),
  allowCredit: z.boolean().default(true),
  creditLimitCents: optionalCents,
  marketingConsent: z.boolean().default(false),
});
export type CustomerInput = z.infer<typeof customerInputSchema>;

export const customerUpdateSchema = customerInputSchema.partial();

export const customerListQuery = paginationQuery.extend({
  q: z.string().trim().max(100).optional(),
  filter: z.enum(['all', 'debtors', 'with_credit', 'inactive_60d', 'birthdays_month']).default('all'),
  sort: z.enum(['name', 'recent', 'top_spent', 'balance_asc', 'last_purchase']).default('name'),
  withBalance: booleanish.optional(),
});
export type CustomerListQuery = z.infer<typeof customerListQuery>;

export const accountEntryInputSchema = z.object({
  type: z.enum(['charge', 'payment', 'adjustment']),
  amountCents: cents.refine((v) => v > 0, 'Informe um valor'),
  /** adjustment: 'debit' aumenta a dívida, 'credit' diminui */
  direction: z.enum(['debit', 'credit']).optional(),
  paymentMethod: z.enum(PAYMENT_METHOD_TYPES).nullish(),
  note: optionalText(300),
});
export type AccountEntryInput = z.infer<typeof accountEntryInputSchema>;

export const customerImportSchema = z.object({
  contacts: z
    .array(
      z.object({
        name: requiredText(120),
        phone: optionalText(30),
        email: z.string().trim().max(254).nullish(),
      }),
    )
    .min(1)
    .max(5000),
  skipDuplicates: z.boolean().default(true),
});
export type CustomerImportInput = z.infer<typeof customerImportSchema>;
